<!--Pagination-->
<div class="pagination-container d-flex align-items-center" *ngIf="total">
  <span>{{text}}</span>
  <nav aria-label="example" *ngIf="total && totalPage > 1">
    <ul class="pagination pg-blue justify-content-end">
      <!--Arrow left-->
      <li class="page-item" *ngIf="totalPage <= 5">
        <span class="page-link" (click)="totalPage > 1 && first()">
          <!-- Trang Đầu -->
          <i class="fa fa-step-backward" aria-hidden="true" title="{{'Trang đầu'}}"></i>
        </span>
      </li>
      <li class="page-item" *ngIf="totalPage > 5" [ngClass]="{'disabled-button': selectedPage === 1}">
        <span class="page-link" (click)="changePage(selectedPage - 5)">
          <i aria-hidden="true" class="fa fa-step-backward"></i>
        </span>
      </li>
      <li class="page-item">
        <span class="page-link" [ngClass]="{'disabled-button': !checkPrevious()}" (click)="previous()">
          <i class="fa fa-caret-left fa-lg" aria-hidden="true"></i>
        </span>
      </li>
      <li class="page-item" *ngFor="let item of pages; index as index">
        <span class="page-link" (click)="changePage(item)"
          [ngClass]="{'active-link background-active-link': item === selectedPage}">
          {{item}}
          <span class="sr-only">(current)</span>
        </span>
      </li>
      <li class="page-item">
        <span class="page-link" [ngClass]="{'disabled-button': !checkNext()}" (click)="next()">
          <i class="fa fa-caret-right fa-lg" aria-hidden="true"></i>
        </span>
      </li>
      <li class="page-item" *ngIf="totalPage > 5" [ngClass]="{'disabled-button': selectedPage === totalPage}">
        <span class="page-link" (click)="changePage(selectedPage + 5)">
          <i aria-hidden="true" class="fa fa-step-forward"></i>
        </span>
      </li>
      <li class="page-item" *ngIf="totalPage <= 5">
        <span class="page-link" (click)="totalPage > 1 && last()" title="{{'Trang cuối'}}">
          <!-- Trang Cuối -->
          <i class="fa fa-step-forward" aria-hidden="true"></i>
        </span>
      </li>
    </ul>
  </nav>
</div>
